import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer,
} from 'recharts';
import styles from './BarChartCard.module.css';

function BarChartCard({ data, xKey, yKey, color = 'var(--color-primary)', height = 280, yFormatter }) {
  return (
    <div className={styles.card}>
      <ResponsiveContainer width="100%" height={height}>
        <BarChart data={data} margin={{ top: 8, right: 16, left: 0, bottom: 40 }}>
          <XAxis
            dataKey={xKey}
            tick={{ fill: 'var(--color-text-secondary)', fontSize: 11 }}
            axisLine={false}
            tickLine={false}
            angle={-35}
            textAnchor="end"
            interval={0}
          />
          <YAxis
            tick={{ fill: 'var(--color-text-secondary)', fontSize: 11 }}
            axisLine={false}
            tickLine={false}
            tickFormatter={yFormatter ?? ((v) => `${v / 1000}K`)}
          />
          <Tooltip
            contentStyle={{
              background: 'var(--color-bg-secondary)',
              border: '1px solid var(--color-border-primary)',
              borderRadius: 8,
              color: 'var(--color-text-primary)',
              fontSize: 12,
            }}
            cursor={{ fill: 'rgba(63,183,96,0.06)' }}
          />
          <Bar dataKey={yKey} fill={color} radius={0} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export default BarChartCard;
